import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function CircleFailure(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0Zm0 21.6c-5.292 0-9.6-4.308-9.6-9.6S6.708 2.4 12 2.4s9.6 4.308 9.6 9.6-4.308 9.6-9.6 9.6z" />
      <path
        d="m17.402 7.81.069-.068-.07-.069L16.329 6.6l-.07-.069-.068.069-4.19 4.19L7.81 6.6l-.07-.069-.068.069-1.074 1.074-.07.069.07.069 4.19 4.19-4.19 4.19-.07.07.07.068 1.074 1.074.069.069.068-.069 4.19-4.19 4.19 4.19.07.069.069-.069 1.074-1.074.069-.069-.07-.069-4.19-4.19z"
        stroke="currentColor"
        strokeWidth=".194595"
      />
    </IconWrapper>
  );
}
